import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M10.53 3.474a.75.75 0 0 0-1.06 0l-3.25 3.25a.75.75 0 0 0 1.06 1.061L10 5.065l2.72 2.72a.75.75 0 1 0 1.06-1.06zm-4.31 9.811 3.25 3.25a.75.75 0 0 0 1.06 0l3.25-3.25a.75.75 0 0 0-1.06-1.06L10 14.943l-2.72-2.72a.75.75 0 1 0-1.06 1.061",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }